export const BATER_BRANDS = [
    'edecb5b9-21bc-447d-8cf6-1a3875d7aee5',
    'c390fa76-e5ba-4b45-8dcf-0021032923d0',
    '4b9467b5-9f0a-40a3-b038-ab581d3a2916',
    '2333e6a6-9e34-48b2-bfd6-b42ce6c9bfd0',
    '8a0ec4b8-bb8e-4a1c-8554-b4d93ccb3c91',
    '6dd6cebe-d6df-46f7-99d6-e87146f524cd',
    '0762ce89-546a-4af5-a5fb-34ade8d7bd89',
    'b4764934-9bde-4c09-a6d8-60a8873523c0',
    '758695fb-a788-46c0-b191-16bf30380c0b',
    '90c6d852-7422-459f-8048-a0e37edf67b9',
    '6c5b565a-5bd2-49c5-a850-1c62deae822d',
    'c4756f09-bb4c-49ee-9215-dccbfb0ef132',
    '7c0c863a-2e60-4ad6-9f36-843d0bf1817a',
    'b0c9d611-3e7f-4835-a006-96f399706708',
    '775a3317-3f31-44c4-89f1-74838155dc59',
    '490cabe1-a7b3-4fbb-9e78-9742ec9a234d',
    '8fb2ced7-3ca3-49c5-a72e-92e0fcc90c72',
    '1b0c3ea4-ee1d-44d4-9400-399045e93e5a',
    'ceeedc85-7e9e-4569-aee6-cac30f4062a1',
    '3aa08f74-c4cc-4303-b989-096cad928cad',
    '2b9b313a-bd23-43f6-9dac-81a90220c429',
    '244e61a9-8c6f-4921-bdb4-e6afc7f45c57',
    '0da0d241-11ec-47ee-887b-14dc117bbd83',
    '53172784-ed18-40fd-81e5-acc536b00aa8',
    'f0802a1f-3dba-4be9-b53d-bac563cd3539',
    '22ac6e71-86ca-48d6-8a3b-2982d0408a8d',
    '05cd0b21-3b49-4f81-a60c-583089574f97',
    '71a790e5-c5ae-4ea5-81e6-1925be8b3577',
    'e51fcde7-bddc-4c57-a0c0-72fc387bedc4',
    '8d29ab5c-25c7-4452-b9e1-9890f0c19c3e',
    'f358d3d9-3e88-4e5d-a7f2-4544e7474b1b',
    '49d89f42-d941-49db-bf2c-524c4339bba3',
    'ce5b4644-fe4c-4206-8cca-042c3a438028',
    'ea056643-c5b3-4a16-bf9a-769459441e54',
    '9edf5573-718e-4ae8-b8aa-79e45b43311e',
    '51db0235-aa6d-4b4b-afc6-3a4901bb0101',
    'c3347810-0b6e-4c7d-b8a9-6309c516823a',
    '02449e34-6c89-4743-8b13-50627e01a1f5',
    '3dfd974f-42bd-47fa-83da-5a83aea20815',
    'a24d85a0-4b0f-4fe6-948d-cb6aaa882873',
    '12848f0c-679f-4998-ac57-9e91a80bbe7f',
    '06ee1d1a-ed1d-4711-8f77-7cdebd8726d8',
    '88ab9685-ddcf-46f0-be59-b0065769a54f',
    'a66e498e-27b1-4094-827d-584c250eb405',
    '8c8d0a0b-b188-4b19-8b57-1f978c229476',
    '188bcd29-0e12-4c56-869a-e178e0f9d738',
    '98b01567-59c4-4927-8863-1e446ac7421d',
    '3e53ad86-08c2-4d13-be6c-e41527f4e878',
    '8b73b383-a0ff-4959-87e1-228c3df657de',
    '2555d627-0651-4d00-8504-efa017136c93',
    '8ea740e3-c27f-4c6f-b60c-4c2bf71cea68',
    'f0102139-92e0-433a-9b71-38228453923e',
    '6deb227b-0165-4f76-88ac-e8ca22672abd',
    'f2fa6fef-2b41-4584-8955-6894d66a46f2',
    'fcd13edf-3f74-4272-915e-24637f170afc',
    '656e3e77-359c-476e-b545-31506f68e952',
    'b57cecf5-fdb9-4545-a300-abc501066d09',
    '943efee3-193c-4ce9-9883-131b4507f989',
    'd6d0fc47-463f-4b5c-b14c-9413b8a283e6',
    '06ffc952-09fd-4fba-9314-0eec4f99132e',
    '9f686a54-8fea-42b0-b26b-18404a18cfbb',
    '2146610e-0232-42e7-9639-de3b182304cd',
    'c78485ef-6d56-4406-b307-d999558b0ac5',
    'e03d2c90-47eb-4efe-8595-25b2061f4a9d',
    '39dd2c18-c19a-4f95-9744-368672e255c1',
    '197c8f0f-24fd-4ec9-8a48-3703e40060a8',
    '892d6cb1-3153-4407-8e0b-83fd17fdcbbe',
    '5b5529fb-e54b-4388-adf5-3264ca82bd68',
    'dd843ef5-3f94-409b-8d60-a1349ef725d6',
    '5e2874f8-8c98-445a-8f30-9967edb31ff7',
    '260fd5e0-598b-48ba-be72-29bc32768421',
    'f66d4671-8abe-4851-9a11-64ff56dc44a8',
    '0e0cb1de-ef03-4c4f-83be-704a2a8ebb30',
    '2613894e-b614-415a-b510-ac0f67d42dec',
    'bddd5343-ad3a-4426-be91-9b673eeb2b4e',
    '1e960671-7866-4147-8af6-0238620ca5f1',
    '3d5ed8a9-72b4-4208-a4ca-fff4783ae60a',
    '4814fe58-d903-44cd-870e-93ba8ecbcc66',
    'c4245b7b-ab7c-42bd-a692-b6ab87d009a1',
    '43d6cf29-ea52-453a-b7cd-9be40800d38d',
    'b243db08-6882-4f0d-a9a0-09f08eb7d460',
    'ba3b9503-8e5d-46b7-aee6-a81fd5b6b9b7',
    '3cf8d374-ff55-4515-bd8c-5ac41cdf4e43',
    'b80da96f-f88f-4763-b5bb-5cc72917a6b1',
    '875a1c85-42dd-4ecd-a6d3-fb25e301db2d',
    'cf0562dc-3ac5-4a9b-aa34-37496fe5f8e3',
    '8b7cf4b0-f19f-46a6-8e35-cbd7a08bb0e7',
    'a98185af-e7be-4541-ac71-d5342a97f5ef',
    '2499fdca-4209-473b-847a-9c067ea68069',
    '280bc335-f3d1-4243-9431-80ad4ab5dc74',
    '94208a9c-428a-4742-b0dd-c210da1d9e56',
    'd0154b30-cf73-4aff-be13-84d37665b24c',
    '51891d3a-ec3d-4ddb-8e93-7de980951174',
    'e253f09d-834a-414a-8a54-5fefd2b850e6',
    '3d039ac3-0128-45ae-8431-9ffa9a264e23',
    'd169f3e1-f5f2-4ba3-aaf6-1ef8ed53ee6a',
    '8ffafb47-b21e-448e-a007-9c4b54e5e46b',
    '85b347eb-f752-4c98-8671-726ac52da265',
    'd9a28b36-3d54-45f2-85f2-19139e1ea989',
    '3dc6a925-5cbe-4692-a7e0-96ec13d7c976',
    '762f64f6-bb26-4a1d-8a11-0c1acebe5a86',
    '8fe6fde3-ab21-473f-b5d5-f44e7c7d7908',
    'fc962b78-3892-4b79-b348-31d5501be15d',
    '5ca410bb-171a-40fc-ab98-463d7335504b',
    'd40b03a1-bb85-4f89-b5fa-e3918a1a5096',
    '36cc6a39-efa5-4fbd-9e4c-ef68cccedc4a',
    'd824173e-af13-4bda-9356-f8de3af2112f',
    '69e0812d-524d-4275-afb7-70b0c8dc0032',
    'fb47f5fd-5585-4839-9b69-24da1b32d803',
    'b1c5dcc0-9e9c-4061-a721-b5c4b135e941',
    '912505df-12d8-4b4d-b987-cfb47711d7c7',
    '677d8334-c11f-4bf0-81ad-7dd29a73bc4e',
    '0de3cd7f-23a7-4553-84e1-bbb0fbcf8b8a',
    '00015d86-a53f-420a-9251-9ebe76536748',
    'c73a46fe-b98a-4194-bb33-ca98fe3f6a6b',
    '3c23593a-3021-48cb-b05f-2f8127a73be8',
    '587ded54-2740-4e6b-ad13-e017cc345659',
    'f9d475a2-74e6-4ab5-93e6-70bbbc1c9151',
    'b25c0a3d-e42b-493e-854c-b691ebdca0de',
    '8ad2b8cf-5a63-4ab4-a4a9-368d694c206f',
    '6343acb9-9bde-49ed-ae9a-87cc0a0ca80f',
    '382f7f7b-67b5-410f-be3e-64252aa051de',
    '9709c646-f949-4be9-bb5b-4db462020a67',
    '254f4588-703c-44ce-bfe7-1d7419983cee',
    '0bb110bc-d9fb-44b1-a8ed-5856783fb7f1',
    '12dbc8c5-dc7c-4dde-8213-2b6d160c80cb',
    '37157fc9-98d9-4c9d-801d-4e1cea6fe010',
    'cd6f1ee5-8234-48d8-aa7f-ed1160d7bf3e'
];

export const BOAT_TYPE_CATEGORIES = [
    {
        id: 72,
        worldMapSetId: '416fe7a6-d8e0-4817-917a-69c569f8b5ae',
        name: 'Skjærgårdsjeep'
    },
    {
        id: 73,
        worldMapSetId: 'de874397-42a1-4501-afa2-fd46c0da53c7',
        name: 'Bow rider'
    },
    {
        id: 74,
        worldMapSetId: '1c28ed13-a0e2-48cf-86f3-2840bb134e4c',
        name: 'RIB'
    },
    {
        id: 77,
        worldMapSetId: 'b340a909-5048-49f0-a15a-81971e661a9c',
        name: 'Cabincruiser'
    },
    {
        id: 76,
        worldMapSetId: '6379b4cf-154a-4718-8aed-5597886aec90',
        name: 'Pilothouse og styrhusbåt'
    },
    {
        id: 75,
        worldMapSetId: 'a8d28894-4648-424f-a702-29a8bedb4fbd',
        name: 'Daycruiser'
    },
    {
        id: 71,
        worldMapSetId: '36ef2e82-e871-4ad2-8673-6fb0c8549cb5',
        name: 'Jolle'
    },
    {
        id: 449,
        worldMapSetId: 'd902079b-b012-4dd9-bf23-1071e7cea520',
        name: 'Snekke'
    },
    {
        id: 78,
        worldMapSetId: '5aefe1fa-89c0-4907-a8b8-ee09593b0048',
        name: 'Seilbåt'
    },
    {
        id: 1675,
        worldMapSetId: '51539d74-e005-409a-815d-5aa022a8e1ad',
        name: 'Gummibåt'
    }
];

export const MOTOR_TYPE_NAME_TO_ID = {
    Utenbords: '38039d58-260a-4e0d-ac67-5757f4d15a40',
    Innenbords: '9aaf8d16-499b-493b-89e8-65f10419aa1d',
    Hybrid: 'bbbeea66-69f7-44a1-af53-075708c405c8',
    Elektrisk: '1bc66479-794c-4ea0-88af-37a3e51d4a56'
};
